<ul class="icon-list">
  @for (item of items(); track $index) {
    <li class="icon-list__item">
      <div class="icon-list__item-icon">
        <ng-container
          [ngTemplateOutlet]="iconTemplate()"
          [ngTemplateOutletContext]="{
            iconName: item.iconName,
          }"
        />
      </div>
      <p class="icon-list__item-text">
        {{ item.text }}
      </p>
    </li>
  }
</ul>
